var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilNotebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_440_2457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.41675 6.41669H5.50008C5.01385 6.41669 4.54754 6.60984 4.20372 6.95366C3.8599 7.29747 3.66675 7.76379 3.66675 8.25002V16.5C3.66675 16.9863 3.8599 17.4526 4.20372 17.7964C4.54754 18.1402 5.01385 18.3334 5.50008 18.3334H13.7501C14.2363 18.3334 14.7026 18.1402 15.0464 17.7964C15.3903 17.4526 15.5834 16.9863 15.5834 16.5V15.5834",
    stroke: "#33303C",
    strokeOpacity: 0.6,
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 4.58334L17.4167 7.33334M18.6863 6.03626C19.0473 5.67523 19.2501 5.18557 19.2501 4.67501C19.2501 4.16444 19.0473 3.67478 18.6863 3.31376C18.3252 2.95273 17.8356 2.74991 17.325 2.74991C16.8144 2.74991 16.3248 2.95273 15.9638 3.31376L8.25 11V13.75H11L18.6863 6.03626Z",
    stroke: "#33303C",
    strokeOpacity: 0.6,
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_440_2457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilNotebook);
export default __webpack_public_path__ + "static/media/pencil-notebook.967990555242d8392c846b23fc23c9ed.svg";
export { ForwardRef as ReactComponent };